import { getUnleashEnv } from './unleash.sdk'

const getLocalStorageValue = (key: string, defaultValue?: any) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const localStored = localStorage.getItem(key)
      if (
        typeof defaultValue === 'string' ||
        defaultValue === undefined ||
        defaultValue === null
      ) {
        return localStored || defaultValue
      }
      const val = (localStored && JSON.parse(localStored)) || defaultValue
      return val
    }
    return defaultValue
  } catch (error) {
    console.error(`Error getting localStorage value for key "${key}":`, error)
    return localStorage.getItem(key) || defaultValue
  }
}

export const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_PROXY_URL as string,
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY as string,
  appName: 'pw-ambassador',
  refreshInterval: 900, // in seconds
  environment: getUnleashEnv(),
  ...(getLocalStorageValue('user', {})?.id
    ? { context: { userId: getLocalStorageValue('user', {})?.id as string } }
    : {}),
}
